//TODO: Make these safe
export const getFileName = file => file.name.substr(0, file.name.lastIndexOf('.'));
export const getFileExtension = file => file.name.substr(file.name.lastIndexOf('.') + 1);
export const getFileContentType = fileType =>
    fileType === 'pdf'
        ? 'application/pdf'
        : fileType === 'xls'
            ? 'application/vnd.ms-excel'
            : fileType === 'xlsx'
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/octet-stream';

export const getIBFileContentType = fileType =>
    fileType === 'zip'
        ? 'application/zip'
        : fileType === 'pdf'
            ? 'application/pdf'
            : fileType === 'xls'
                ? 'application/vnd.ms-excel'
                : fileType === 'xlsx'
                    ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    : 'application/octet-stream';

                
export const getArrayBuffer = base64 => {
    let binaryString = window.atob(base64);
    let bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};

export const getDateRangeTitle = (start,end) => (start && end) ? `${start} to ${end}` : (start || end) ? (start || end) : ''

export const getBulkDownloadTitle = data => data.molecule ? data.molecule : getDateRangeTitle(data.distributedStartDt, data.distributedEndDt)
    